<bp-loading-overlay [isLoading]="!documentsRetrieved"></bp-loading-overlay>
<ng-container>
    <h3>Verification documents</h3>
    <mat-card>
        <p>
            The following documents must be uploaded before you can confirm that installation of the {{txt.EligibleEquipment}} has been completed.
            <br />
            These documents will be reviewed to ensure compliance with the terms and conditions of the {{txt.schemeName}}.
        </p>

        <ng-container *ngIf="!isWaScheme()">
            <div class="document-upload-section" *ngFor="let requiredDocument of getRequiredDocuments()">
                <p>
                    <strong>
                        {{requiredDocument.callToAction}}
                        <span *ngIf="requiredDocument.additionalRequirements.length > 1">
                            <br/>Ensure that:
                        </span>
                    </strong>

                    <span *ngIf="requiredDocument.additionalRequirements.length === 1">
                        <br/>Ensure that {{requiredDocument.additionalRequirements[0]}}
                    </span>
                </p>

                <ul *ngIf="requiredDocument.additionalRequirements.length > 1">
                    <li *ngFor="let requirement of requiredDocument.additionalRequirements">
                        {{requirement}}
                    </li>
                </ul>

                <mat-expansion-panel *ngIf="requiredDocument.type === quoteDocumentUploadTypes.InstallationPhotograph"
                    class="detailed-instructions-panel" #panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>Required photographs</mat-panel-title>
                        <mat-panel-description>Click to {{panel.expanded ? 'hide' : 'expand'}}</mat-panel-description>
                    </mat-expansion-panel-header>
                    <nsw-document-requirements *ngIf="!isSapnScheme()" [quoteFormModel]="quoteFormModel"></nsw-document-requirements>
                </mat-expansion-panel>

                <quote-form-upload [quoteExternalId]="quoteExternalId" [quoteDocumentUploadType]="requiredDocument.type"
                    [uploadedDocuments]="uploadedDocuments[requiredDocument.type]" (onUploadedDocumentsRequested)="getUploadedDocuments()"
                    (onDeleteDocument)="onDeleteDocument($event)" [useMultiUpload]="requiredDocument.useMultiUpload" [canDelete]="canDeleteDocument">
                </quote-form-upload>
            </div>
        </ng-container>
        <ng-container *ngIf="isWaScheme()">
            <div class="document-upload-section" *ngFor="let requiredDocument of getRequiredDocumentsWithoutBillAndRatesNotice()">
                <p>
                    <strong>
                        {{requiredDocument.callToAction}}
                        <span *ngIf="requiredDocument.additionalRequirements.length > 1">
                            <br/>Ensure that:
                        </span>
                    </strong>

                    <span *ngIf="requiredDocument.additionalRequirements.length === 1">
                        <br/>Ensure that {{requiredDocument.additionalRequirements[0]}}
                    </span>
                </p>

                <ul *ngIf="requiredDocument.additionalRequirements.length > 1">
                    <li *ngFor="let requirement of requiredDocument.additionalRequirements">
                        {{requirement}}
                    </li>
                </ul>

                <quote-form-upload [quoteExternalId]="quoteExternalId" [quoteDocumentUploadType]="requiredDocument.type"
                    [uploadedDocuments]="uploadedDocuments[requiredDocument.type]" (onUploadedDocumentsRequested)="getUploadedDocuments()"
                    (onDeleteDocument)="onDeleteDocument($event)" [useMultiUpload]="requiredDocument.useMultiUpload" [canDelete]="canDeleteDocument">
                </quote-form-upload>
            </div>
        </ng-container>
        <div class="document-upload-section" *ngIf="isWaScheme() && isBillAndRatesNoticeIncludedInRequiredDocuments()">
            <p>
                <strong>
                    Please upload a copy of the customer's rates notice or electricity bill
                </strong>
                <span>
                    <br/>Ensure that either the rates notice or the electricity bill is uploaded so that we can verify your customer's address
                </span>
            </p>
            <ng-container *ngIf="!(uploadedDocuments[quoteDocumentUploadTypes.RatesNotice]?.length > 0)">
                <quote-form-upload [quoteExternalId]="quoteExternalId" [quoteDocumentUploadType]="quoteDocumentUploadTypes.Bill"
                    [uploadedDocuments]="uploadedDocuments[quoteDocumentUploadTypes.Bill]" (onUploadedDocumentsRequested)="getUploadedDocuments()"
                    (onDeleteDocument)="onDeleteDocument($event)" [useMultiUpload]="false" [canDelete]="canDeleteDocument">
                </quote-form-upload>
            </ng-container>
            <ng-container *ngIf="!(uploadedDocuments[quoteDocumentUploadTypes.Bill]?.length > 0)">
                <br />
                <quote-form-upload [quoteExternalId]="quoteExternalId" [quoteDocumentUploadType]="quoteDocumentUploadTypes.RatesNotice"
                    [uploadedDocuments]="uploadedDocuments[quoteDocumentUploadTypes.RatesNotice]" (onUploadedDocumentsRequested)="getUploadedDocuments()"
                    (onDeleteDocument)="onDeleteDocument($event)" [useMultiUpload]="false" [canDelete]="canDeleteDocument">
                </quote-form-upload>
            </ng-container>
        </div>
    </mat-card>

    <mat-card class="installer-details-card" *ngIf="shouldShowInstallerDetails">
        <h3>Installer Details</h3>
        <p>Please provide the accreditation details for the installer(s).</p>

        <ng-container
            *ngIf="
                quoteFormModel.accreditationNumbers && quoteFormModel.accreditationNumbers.length > 0;
                else provideDetails
            "
        >
            <div class="details-provided">
                <mat-icon color="primary">check_circle</mat-icon>
                <span>Installer details have been provided.</span>
                <button mat-stroked-button color="primary" (click)="openInstallerDetailsDialog()">Edit Details</button>
            </div>
        </ng-container>

        <ng-template #provideDetails>
            <button mat-raised-button color="primary" (click)="openInstallerDetailsDialog()">
                Provide Installer Details
            </button>
        </ng-template>
    </mat-card>
</ng-container>

